<script>
import { updateKitItem } from "@/api/store/ProductsService.js";

import KitItemForm from "./KitItemForm.vue";
export default {
  components: {
    KitItemForm
  },
  props: {
    kitCode: {
      type: String,
      required: true
    },
    item: {
      type: String,
      required: true
    }
  },
  methods: {
    submit(newItem) {
      updateKitItem(this.kitCode, newItem)
        .then(() => {
          this.$toast.open({
            message: `The kit item ${newItem.code} was updated`,
            type: "success",
            position: "top-right"
          });
          this.$emit("kitItemUpddated");
        })
        .catch(() => {
          this.$toast.open({
            message: `Error updating kit item ${newItem.code}`,
            type: "error",
            position: "top-right"
          });
        });
    }
  }
};
</script>
<template>
  <BaseModal id="kit-product-modal" :value="true" @input="$emit('close')">
    <template v-slot:header> Update Item {{ item.code }} </template>
    <div class="flex flex-col w-full">
      <KitItemForm :value="item" @submit="submit">
        <button
          class="btn btn-success-button w-20 flex justify-center items-center"
        >
          create
        </button>
      </KitItemForm>
      <div></div>
    </div>
  </BaseModal>
</template>
<style lang="scss">
#kit-product-modal {
  .modal-content {
    max-width: 900px;
    height: fit-content;
    max-height: 100%;
  }
}
</style>
